import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { ConnectProviderRequest, ProviderConnection } from '../types/domain';

export function providerEndpoints(http: HttpClient) {
  return {
    list: () => http.get<ApiEnvelope<ProviderConnection[]>>('/v1/providers').then(unwrap),
    connect: (body: ConnectProviderRequest) => http.post<ApiEnvelope<ProviderConnection>>('/v1/providers/connect', body).then(unwrap),
  };
}
export type ProviderEndpoints = ReturnType<typeof providerEndpoints>;
